import { t } from "../../../i18n";
import { fmt, type CaseId } from "@tasduvar/engine";
import type { ReportModel } from "../model";
import { classicSummary, InfoVerdict, Section, Verdict } from "./common";
import { advisoryCoverTitle, advisoryLine, reportAdvisories } from "../advisories";

export function Summary({ m }: { m: ReportModel }): JSX.Element {
  const allOk = m.walls.every((w) => w.result?.ok);
  const adv = reportAdvisories(m.project, m.walls);
  const minRatio = (r: NonNullable<ReportModel["walls"][number]["result"]>, key: "overturning" | "sliding" | "bearing"): number =>
    Math.max(...(Object.keys(r.cases) as CaseId[]).map((c) => r.cases[c]![key].tbdy?.ratio ?? 0));
  return (
    <Section id="summary" title={t("14. Sonuç ve Değerlendirme")}>
      <table>
        <thead><tr><th>{t("Duvar")}</th><th className="num">{t("Devrilme (en büyük oran)")}</th><th className="num">{t("Kayma")}</th><th className="num">{t("Taşıma gücü")}</th><th>{t("İç kesitler / kesit tasarımı")}</th><th>TBDY</th><th>{t("Klasik")}</th><th>{t("Genel")}</th></tr></thead>
        <tbody>
          {m.walls.map(({ wall, result, error }) => result ? (
            <tr key={wall.id}>
              <td>{wall.name}</td>
              <td className="num">{fmt(minRatio(result, "overturning"), 2)}</td><td className="num">{fmt(minRatio(result, "sliding"), 2)}</td><td className="num">{fmt(minRatio(result, "bearing"), 2)}</td>
              <td>{result.rc ? <Verdict ok={result.rc.ok} /> : result.joints.length ? <Verdict ok={result.joints.every((j) => j.allOk)} /> : "—"}</td>
              <td><Verdict ok={(Object.keys(result.cases) as CaseId[]).every((c) => { const x = result.cases[c]!; return (x.overturning.tbdy?.ok ?? true) && (x.sliding.tbdy?.ok ?? true) && (x.bearing.tbdy?.ok ?? true); })} /></td>
              <td>{((v) => v === "info" ? <InfoVerdict /> : <Verdict ok={v} />)(classicSummary(result))}</td>
              <td><Verdict ok={result.ok} /></td>
            </tr>
          ) : <tr key={wall.id}><td>{wall.name}</td><td colSpan={7} className="bad">{t("Hesap yapılamadı:")} {error}</td></tr>)}
        </tbody>
      </table>
      <div className={`verdict-box ${allOk ? "ok" : "bad"}`}>{allOk ? t("TÜM DUVARLAR İÇİN STABİLİTE KOŞULLARI SAĞLANMAKTADIR") : t("STABİLİTE KOŞULLARI SAĞLANMAYAN DUVAR VARDIR — KESİT VEYA ZEMİN PARAMETRELERİ GÖZDEN GEÇİRİLMELİDİR")}</div>
      {adv.length ? (
        <div className="advisory-box" style={{ width: "auto" }} data-summary-advisories>
          <strong>{advisoryCoverTitle(adv.length)}</strong>
          {adv.map((a) => <p key={a.id}>{advisoryLine(a)}</p>)}
        </div>
      ) : null}
    </Section>
  );
}
